module.exports = __webpack_public_path__ + "static/media/16.ec8b0e28.jpg";